export const matchingNameMultiselection = (input: any, list: any) => list?.filter((inputVal: any) =>
input?.some((area: any) => area.id === inputVal.id)
);

export const matchingNameMultiselectionExt = (input: any, list: any) => 
  input?.map((input: any) => {
    const foundObject = list.find((obj: any) => obj.value === input.id)
    return foundObject || { value: input.id, label: input.name }
});
